import Loadable from "react-loadable";

export const MissingLongVideo = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.MissingVideoButton) as Promise<any>,
  loading: () => null,
});
